import { type FC, useCallback } from 'react';

import { PikInNumbers } from './PikInNumbers';
import { trackShowPikInNumbersSection } from './internal/tracking/trackShowPikInNumbersSection';

export const PikInNumbersContainer: FC = () => {
  const handleView = useCallback(() => trackShowPikInNumbersSection(), []);

  return <PikInNumbers onView={handleView} />;
};
